import {
  Box,
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuList,
  MenuGroup,
  MenuItem,
  Text,
  Spinner,
} from "@chakra-ui/react";
import { AiOutlineSearch } from "react-icons/ai";
import { BiArrowBack, BiChevronDown } from "react-icons/bi";
import { nanoid } from "nanoid";
import { useQueryWrapper } from "services/apiHelper";
import { categoryRequest } from "services/request";
import { queryKeys } from "services/querykeys";
import { type CategoryType } from "utils/constants";

interface SearchBarProps {
  searchText: string;
  onChange: (event) => void;
  handleBack?: () => void;
  showDropdown: boolean;
  hideDropdown: () => void;
  searchResult: any[];
  resultClick: (term) => void;
  currentCat: string;
  setcurrentCat: (value) => void;
  handleHide: () => void;
}
const SearchBar = (props: SearchBarProps) => {
  const {
    searchText,
    onChange,
    showDropdown,
    handleBack,
    searchResult,
    resultClick,
    currentCat,
    setcurrentCat,
  } = props;
  const { data, isLoading } = useQueryWrapper(queryKeys.CATEGORIES, categoryRequest.CATEGORIES, {
    staleTime: 30 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  const categories: CategoryType[] = data?.data ?? [];
  const groupedCategories = categories.reduce<Record<string, CategoryType[]>>((acc, category) => {
    if (category.name === "All" || category.name === "Other / Not Listed") return acc;
    const group = category.group ?? "General";
    acc[group] = [...(acc[group] ?? []), category];
    return acc;
  }, {});

  return (
    <Flex alignItems="center" width="100%" position="relative">
      {handleBack != null && (
        <Button bg="#fff" rounded="none" color="black" onClick={handleBack} variant="ghost">
          <BiArrowBack size={20} />
        </Button>
      )}
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <AiOutlineSearch color="gray.300" />
        </InputLeftElement>
        <Input
          rounded="none"
          value={searchText}
          onChange={onChange}
          type="text"
          placeholder="Search for scripts"
          bg="white"
        />
        <InputRightElement width="max-content" mr="2">
          <Menu>
            <MenuButton as="span" h="1.75rem" mr={2}>
              <Flex alignItems="center">
                <Text color="#7F94A6" fontSize="sm">
                  {currentCat}
                </Text>{" "}
                <BiChevronDown color="#7F94A6" />
              </Flex>
            </MenuButton>
            <MenuList fontSize="sm">
              <MenuItem
                onClick={() => {
                  setcurrentCat("All");
                }}
              >
                All
              </MenuItem>
              {isLoading && <Spinner size="sm" mx="3" my="2" />}
              {Object.entries(groupedCategories).map(([group, groupCategories]) => (
                <Box key={group}>
                  <MenuGroup title={group}>
                    {groupCategories.map((category) => (
                      <MenuItem
                        key={category.id}
                        onClick={() => {
                          setcurrentCat(category.name);
                        }}
                      >
                        {category.name}
                      </MenuItem>
                    ))}
                  </MenuGroup>
                  <MenuDivider />
                </Box>
              ))}
              <MenuGroup title="Others">
                <MenuItem
                  onClick={() => {
                    setcurrentCat("Composer");
                  }}
                >
                  Composer
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setcurrentCat("Custom Category");
                  }}
                >
                  Custom Category
                </MenuItem>
              </MenuGroup>
            </MenuList>
          </Menu>
        </InputRightElement>
      </InputGroup>
      {showDropdown && (
        <Box
          position="absolute"
          bg="#fff"
          width="100%"
          zIndex="5"
          top="40px"
          border="1px solid #dbe3e9"
          // ref={domNode}
        >
          {searchResult.map((result) => (
            <Button
              key={nanoid()}
              onClick={() => {
                resultClick(result);
              }}
              variant="unstyled"
              rounded="none"
              pl="4"
              fontWeight="normal"
              w="100%"
              textAlign="left"
              _hover={{ backgroundColor: "#dbe3e9" }}
            >
              {result}
            </Button>
          ))}
        </Box>
      )}
    </Flex>
  );
};

export default SearchBar;
